<template>
  <el-dialog
    :visible="true"
    width="700px"
    :show-close="false"
    :close-on-click-modal="false"
    custom-class="chartDia"
  >
    <div slot="title" class="slotTit">{{ cashObj | transTit }}</div>
    <div v-if="cashObj.authStatus == 1">
      <img src="@/assets/3.png" />
      <div class="word1">支付中</div>
      <div class="word2">系统正在对订单进行支付，请耐心等待。</div>
    </div>
    <div v-else-if="cashObj.authStatus == 2 && cashObj.payStatus == 3">
      <img src="@/assets/2.png" />
      <div class="word1">提现失败</div>
    </div>
    <div v-else-if="cashObj.authStatus == 2 && cashObj.payStatus == 2">
      <img src="@/assets/1.png" />
      <div class="word1">提现成功</div>
      <div class="word2">已提现至您的银行账户</div>
    </div>
    <div v-else-if="cashObj.authStatus == 2 && cashObj.payStatus != 2">
      <img src="@/assets/3.png" />
      <div class="word1">支付中</div>
      <div class="word2">系统正在对订单进行支付，请耐心等待。</div>
    </div>
    <div v-else-if="cashObj.authStatus == 3">
      <img src="@/assets/2.png" />
      <div class="word1">提现失败</div>
    </div>
    <div class="flexBox">
      <!-- <div>
        <label>提现流水号：</label>
        {{cashObj.orderNo}}
      </div>-->
      <div style="min-width: 320px">
        <label>提现时间：</label>
        {{ cashObj.payDt | transAllTime }}
      </div>
    </div>
    <div class="flexBox">
      <div label="公司名称：">
        <label>公司名称：</label>
        {{ cashObj.companyName }}
      </div>
      <div label="银行账号：">
        <label>银行账号：</label>
        {{ cashObj.openBankNumber }}
      </div>
    </div>
    <div class="flexBox">
      <div>
        <label>开户行：</label>
        {{ cashObj.openBankName }}
      </div>
      <div label="银行账号：">
        <label>提现通道：</label>
        {{ bankText }}
      </div>
    </div>
    <div class="flexBox">
      <div>
        <label>待提现金额：</label>
        <span style="color:#1989FA;font-weight:normal;">
          {{ cashObj.price | money }}
        </span>
        元
      </div>
      <div>
        <label>实际到账金额：</label>
        <span style="color:#FAB119">
          {{ (cashObj.price - cashObj.servicePrice) | money }}
        </span>
        元
      </div>
    </div>
    <div class="flexBox">
      <div>
        <label>手续费：</label>
        {{ cashObj.servicePrice | money }}元
      </div>
    </div>
    <div class="flexBox" style="justify-content:center;">
      <el-button
        @click="reCash"
        type="primary"
        style="margin-right:20px;"
        v-if="cashObj.authStatus == 3 || cashObj.payStatus === 3"
      >
        重新发起提现
      </el-button>
      <el-button
        @click="reCash"
        type="primary"
        style="margin-right:20px;"
        v-if="cashObj.authStatus == 2 && cashObj.payStatus == 2"
      >
        重新发起提现
      </el-button>
      <el-button
        style="border-radius:4px;border:2px solid rgb(25,137,250);color:rgb(25,137,250)"
        @click="confirm"
        clearable
      >
        确定
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
import { withdrawals } from '@/api/ajax';
import { payBankFormatter } from '@/common/fields/bank';

export default {
  props: {
    cashObj: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      ruleForm: {
        cashNum: ''
      },
      text: '获取验证码',
      timer: null,
      code: ''
    };
  },
  computed: {
    bankText() {
      return payBankFormatter(this.cashObj);
    }
  },
  methods: {
    send() {
      //确认提现
      withdrawals.sendWithdrawalsMsg().then(() => {
        this.$message({
          type: 'success',
          message: '发送成功，请注意查收'
        });
        this.text = 60;
        this.timer = setInterval(() => {
          if (this.text > 0) {
            this.text--;
          } else {
            this.text = '获取验证码';
            clearInterval(this.timer);
          }
        }, 1000);
      });
    },
    reCash() {
      this.$parent.componentName = 'cash';
    },
    confirm() {
      this.$parent.componentName = '';
    },
    cancel() {
      this.$parent.componentName = '';
    }
  },
  created() {},
  filters: {
    transTit(v) {
      if (v.authStatus === 2 && v.payStatus === 2) {
        return '提现申请审核成功';
      } else if (v.authStatus === 3 || v.payStatus === 3) {
        return '提现申请审核失败';
      } else {
        return '提现申请审核中';
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
</script>
<style lang="scss" scoped>
.word1 {
  font-size: 24px;
  color: #2e2f2f;
  margin: 25px auto;
}
.word2 {
  color: #b4cfff;
  font-size: 16px;
  margin-bottom: 70px;
}
.chartDia .flexBox {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  align-items: baseline;
  label {
    color: #bfbfbf;
    font-size: 14px;
    width: 100px;
    text-align: right;
    display: block;
  }
  div {
    color: #232f2f;
    font-size: 14px;
    display: flex;
  }
  div:first-of-type {
    width: 60%;
  }
  div:last-of-type {
    width: 40%;
  }
}
</style>
